import React from "react";
import "./precisionClicker.css";
import { Link, useNavigate } from "react-router-dom";
import HeaderLink from "../common/headerLink";
import RainbowButton from "../common/rainbowButton";
import { screens } from "../utils/links";

export default function PrecisionClickerHowTo() {
  const navigate = useNavigate();

  return (
    <div>
      <HeaderLink />
      <section className="instructions">
        <h2>
          How to play <span className="rainbow-text">Precision Clicker</span>
        </h2>
        <ul>
          <li>A shape appears on screen — click as close to its center as possible</li>
          <li>Perfect center hit = 100 points. Distance from center reduces your score</li>
          <li>Each level the timer gets shorter and the penalty for missing gets steeper</li>
          <li>Miss badly enough (or let the timer run out) and you earn a strike</li>
          <li>3 strikes and the game is over</li>
        </ul>
        <p className="cta-container">
          <Link className="cta" to={screens.precisionClicker.play}>
            <RainbowButton>Play Now</RainbowButton>
          </Link>
          <button
            className="no-button fake-link cta"
            onClick={() => navigate(-1)}
          >
            Go Back
          </button>
        </p>
      </section>
    </div>
  );
}
